// src/stores/useMetricFormStore.ts
import { create } from 'zustand';

interface MetricFormState {
  // Keyed by metricId to support multiple inputs in the dynamic form simultaneously
  draftValues: Record<string, string>;
  errors: Record<string, string | null>;
  setDraftValue: (metricId: string, value: string) => void;
  setError: (metricId: string, error: string | null) => void;
  clearDraft: (metricId: string) => void;
  resetAll: () => void;
}

export const useMetricFormStore = create<MetricFormState>((set) => ({
  draftValues: {},
  errors: {},
  setDraftValue: (metricId, value) =>
    set((state) => ({
      draftValues: { ...state.draftValues, [metricId]: value },
      // Automatically clear any existing validation error as the user types
      errors: { ...state.errors, [metricId]: null },
    })),
  setError: (metricId, error) =>
    set((state) => ({
      errors: { ...state.errors, [metricId]: error },
    })),
  clearDraft: (metricId) =>
    set((state) => {
      const nextDrafts = { ...state.draftValues };
      const nextErrors = { ...state.errors };
      delete nextDrafts[metricId];
      delete nextErrors[metricId];
      return { draftValues: nextDrafts, errors: nextErrors };
    }),
  resetAll: () => set({ draftValues: {}, errors: {} }),
}));
